import setAuthorizationToken from '../utils/setAuthorizationToken'
import {
  loginUser,
  updateUser,
  getLoggedInUser,
  updateShippingRequest,
  addShippingRequest,
  getAllCustomersRequest,
  getCustomerDetailRequest,
} from '../services/mightyWifiApi'
import {
  SET_CURRENT_USER,
  SET_LOGGEDIN_USER,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_CUSTOMER_DETAIL_SUCCESS,
} from './types'
export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user,
  }
}

export function logout() {
  return dispatch => {
    localStorage.removeItem('jwtToken')
    setAuthorizationToken(false)
    dispatch(setCurrentUser({}))
  }
}

export function login(data) {
  return dispatch => {
    var loginPayload = {
      email: data.email,
      password: data.password,
    }

    return loginUser(loginPayload).then(res => {
      if (res.success) {
        const token = res.token
        localStorage.setItem('jwtToken', JSON.stringify(res))
        setAuthorizationToken(token)
        dispatch(setCurrentUser(res))
      }
    })
  }
}

export function updateUserRequest(payload) {
  return disptach => {
    return updateUser(payload)
  }
}

export function geCurrentUser(payload) {
  return dispatch => {
    return getLoggedInUser().then(res => {
      dispatch({
        type: SET_LOGGEDIN_USER,
        profile: Object.assign({}, res.data),
      })
    })
  }
}

export function updateShipping(payload) {
  return disptach => {
    return updateShippingRequest(payload)
  }
}

export function addShipping(payload) {
  return disptach => {
    return addShippingRequest(payload)
  }
}

/*export function getAllCustomers() {
  return dispatch => {
    return getAllCustomersRequest()
      .then(res => {
        if (res.status) {
          dispatch({
            type: GET_ALL_CUSTOMERS_SUCCESS,
            customers: Object.assign([], res.data),
          })
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          localStorage.removeItem('jwtToken')
          setAuthorizationToken(false)
          dispatch(setCurrentUser({}))
        }
      })
  }
}*/
export function getAllCustomers(page, limit, column, sortDir, searchText) {
  return dispatch => {
    return getAllCustomersRequest(page, limit, column, sortDir, searchText)
        .then(res => {
          if (res.status) {
            dispatch({
              type: GET_ALL_CUSTOMERS_SUCCESS,
              page: res.page,
              total: res.total,
              customers: Object.assign([], res.data),
            })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            localStorage.removeItem('jwtToken')
            setAuthorizationToken(false)
            dispatch(setCurrentUser({}))
          }
        })
  }
}

export function getCustomerDetail(userId) {
  return dispatch => {
    return getCustomerDetailRequest(userId)
        .then(res => {
          if (res.status) {
            dispatch({
              type: GET_CUSTOMER_DETAIL_SUCCESS,
              customer: Object.assign([], res.data),
            })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            localStorage.removeItem('jwtToken')
            setAuthorizationToken(false)
            dispatch(setCurrentUser({}))
          }
        })
  }
}



// WEBPACK FOOTER //
// ./src/ducks/actions/authActions.js